import { localeISO } from "../../../../../utilities/localeIso";

export const formatExtrapayRate = (value) => {
  const number = Number(value) || 0;
  return number.toLocaleString(localeISO, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 8,
  });
};

export const formatExtrapayDateTime = (dateStamp) => {
  const date = new Date(dateStamp);
  if (Number.isNaN(date.getTime())) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year}, ${hours}:${minutes}`;
};

export const parseExtrapayAmount = (value) => {
  if (value == null) return NaN;
  const normalized = String(value).trim().replace(/\s/g, "").replace(",", ".");
  if (!normalized) return NaN;
  return Number(normalized);
};
